import SUR000100 from "./Components/TemplatesShowSegments/SUR000100";
import SUR000200 from "./Components/TemplatesShowSegments/SUR000200";
import SUR000300 from "./Components/TemplatesShowSegments/SUR000300";
import VOC000100 from "./Components/TemplatesShowSegments/VOC000100";
import TEX000100 from "./Components/TemplatesShowSegments/TEX000100";
import VID000100 from "./Components/TemplatesShowSegments/VID000100";
import SUR076100 from "./Components/TemplatesShowSegments/SUR076100";
import SUR076200 from "./Components/TemplatesShowSegments/SUR076200";
import SUR076700 from "./Components/TemplatesShowSegments/SUR076700";
import TEX076100 from "./Components/TemplatesShowSegments/TEX076100";
import TEX113100 from "./Components/TemplatesShowSegments/TEX113100";
import VOC076100 from "./Components/TemplatesShowSegments/VOC076100";
import VOC076200 from "./Components/TemplatesShowSegments/VOC076200";
import VOC113100 from "./Components/TemplatesShowSegments/VOC113100";
import VOC113200 from "./Components/TemplatesShowSegments/VOC113200";
import VID076200 from "./Components/TemplatesShowSegments/VID076200"; 
import SUR000400 from "./Components/TemplatesShowSegments/SUR000400";
import GAM076100 from "./Components/TemplatesShowSegments/GAM076100";
import IMA076100 from "./Components/TemplatesShowSegments/IMA076100";
import VID484400 from "./Components/TemplatesShowSegments/VID484400";
import TEX501100 from "./Components/TemplatesShowSegments/TEX501100";
import VID484500 from "./Components/TemplatesShowSegments/VID484500";
import VID508400 from "./Components/TemplatesShowSegments/VID508400";

export const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;
export const BASE_URL = `${ROOT_URL}/api/1`;
export const MAP_TEMPLATES_SHOW_SEGMENTS = {
    'GAM-076-100': GAM076100,
    'SUR-000-100': SUR000100,
    'SUR-000-200': SUR000200,
    'SUR-000-300': SUR000300,
    'SUR-000-400': SUR000400,
    'SUR-076-100': SUR076100,
    'SUR-076-200': SUR076200,
    'SUR-076-700': SUR076700,
    'TEX-076-100': TEX076100,
    'TEX-000-100': TEX000100,
    // Pour France Inter X01 => permet de gérer la CSS FranceInterSansFooter avec le même modèle
    'TEX-113-100': TEX113100,
    'TEX-113-101': TEX113100,
    'VID-000-100': VID000100,
    'VID-076-200': VID076200,
    'VOC-000-100': VOC000100,
    'VOC-076-100': VOC076100,
    'VOC-076-200': VOC076200,
    // Pour France Inter X01 => permet de gérer la CSS FranceInterSansFooter avec le même modèle
    'VOC-113-100': VOC113100,
    'VOC-113-101': VOC113100,
    // Pour France Inter X01 => permet de gérer la CSS FranceInterSansFooter avec le même modèle
    'VOC-113-200': VOC113200,
    'VOC-113-201': VOC113200,
    'IMA-076-100': IMA076100,
    'VID-484-400': VID484400,
    'VID-506-400': VID484400,
    'VID-501-400': VID484400,
    'VID-507-400': VID484400,
    'TEX-484-100': TEX501100,
    'TEX-506-100': TEX501100,
    'TEX-501-100': TEX501100,
    'TEX-507-100': TEX501100,
    'VID-484-500': VID484500,
    'VID-506-500': VID484500,
    'VID-501-500': VID484500,
    'VID-507-500': VID484500,
    'VID-080-400': VID508400, // For tests purpose
    'VID-508-400': VID508400,
};
export const API_ENDPOINTS = {
    interactions: `${BASE_URL}/interactions/`,
    upload: `${BASE_URL}/upload/`,
    segment: (id) => `${BASE_URL}/show_segments/${id}/`,
    styles: (id) => `${BASE_URL}/show_segments/${id}/styles`,
    channel: (id) => `${BASE_URL}/channels/${id}/`,
    userData: (id, jwt) => `${BASE_URL}/channels/${id}/user/${jwt}`,
    VoteResults: (id) => `${BASE_URL}/show_segments/${id}/vote-results/`,
    getTemplateShowSegmentByWidgetModel: (widgetModel) => `${BASE_URL}/templates_show_segments/widget_model/${widgetModel}/`,
    alreadyVoted: (id, deviceId) => `${BASE_URL}/interactions/already_reply/${id}/${deviceId}/`
};

export const GOOGLE_STORAGE_API = 'https://storage.googleapis.com/';
export const STATIC_BUCKET = '/static-voxm/';

// Génération d'un uuidv4 uniquement pour les tests en local
export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16));
}